import axios from 'axios';
import API_CONFIG from '../config/api';

// POST consent for authenticated users
export async function syncConsent(consent) {
  // Backend endpoint contract
  // POST /privacy/consent
  // { consent_version, timestamp, categories: {...}, region, ip_hash }
  return axios.post(`${API_CONFIG.API_URL}/privacy/consent`, consent, {
    headers: { 'Content-Type': 'application/json' }
  });
}
